import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { ShoppingBagIcon, ArrowRightIcon } from "@heroicons/react/24/outline"
import { navigate } from "vike/client/router"

export default function ShoppingCartEmpty({ store }) {
  const texts = TextBundle({ id: "aldoo-store" })

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 bg-primary/5 rounded-2xl">
      <div className="bg-primary/10 p-6 rounded-full mb-6">
        <ShoppingBagIcon className="w-12 h-12 text-primary" />
      </div>

      <Typography component="h1" variant="h4" className="text-center mb-3">
        {texts?.empty_cart_title || "Your cart is empty"}
      </Typography>

      <Typography variant="txt_dim" className="text-center max-w-md mb-8">
        {texts?.empty_cart_subtitle || "Looks like you haven't added anything to your cart yet."}
      </Typography>

      <Button
        variant="secondary"
        className="flex items-center gap-2"
        onClick={() => {
          store.hideCart()
          navigate("/pricing")
        }}
      >
        {texts?.empty_cart_cta || "Start Shopping"}
        <ArrowRightIcon className="w-4 h-4" />
      </Button>
    </div>
  )
}
